import OrganizationInputForm from './OrganizationInputForm';

export default OrganizationInputForm;
